module.exports = __webpack_public_path__ + "static/celebration-ed417f9400e1286380ee38a4aab4871f.jpeg";